import React from 'react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {/* Admin Stats Card */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Admin Statistics</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">Total Users</span>
              <span className="text-lg font-semibold text-gray-900">1,234</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">Active Users</span>
              <span className="text-lg font-semibold text-gray-900">987</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">New Users (24h)</span>
              <span className="text-lg font-semibold text-gray-900">45</span>
            </div>
          </div>
        </div>

        {/* Quick Actions Card */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Quick Actions</h3>
          <div className="space-y-2">
            <Link
              to="/admin/users"
              className="block w-full px-4 py-2 text-sm font-medium text-white bg-[#009efb] rounded-md hover:bg-[#0089db] transition-colors duration-200"
            >
              Manage Users
            </Link>
            <Link
              to="/admin/settings"
              className="block w-full px-4 py-2 text-sm font-medium text-white bg-[#009efb] rounded-md hover:bg-[#0089db] transition-colors duration-200"
            >
              System Settings
            </Link>
            <Link
              to="/admin/reports"
              className="block w-full px-4 py-2 text-sm font-medium text-white bg-[#009efb] rounded-md hover:bg-[#0089db] transition-colors duration-200"
            >
              View Reports
            </Link>
          </div>
        </div>

        {/* Recent Activity Card */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Recent Activity</h3>
          <div className="space-y-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="h-8 w-8 rounded-full bg-[#009efb] flex items-center justify-center">
                  <span className="text-white text-sm">JD</span>
                </div>
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-900">John Doe</p>
                <p className="text-sm text-gray-500">Created new user account</p>
              </div>
              <div className="ml-auto text-sm text-gray-500">2h ago</div>
            </div>
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="h-8 w-8 rounded-full bg-[#009efb] flex items-center justify-center">
                  <span className="text-white text-sm">AS</span>
                </div>
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-900">Alice Smith</p>
                <p className="text-sm text-gray-500">Updated system settings</p>
              </div>
              <div className="ml-auto text-sm text-gray-500">4h ago</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 